import { type FC } from "react";
import server from "../../../../assets/images/server.jpg";
import { useTypedTranslation } from "../../../hooks";
import * as Styled from "../InflationStepper.styled";
import { InflationStepperProps } from "../InflationStepper.types";

type FailProps = InflationStepperProps;

export const Fail: FC<FailProps> = ({ modal }) => {
    const { t } = useTypedTranslation();

    return (
        <>
            <Styled.ImageWrapper>
                <Styled.MuiImage src={server} alt={"error"} />
            </Styled.ImageWrapper>

            <Styled.BodyText>{t("inflationStepper.error.changeFailedTitle")}</Styled.BodyText>
            <Styled.BodyDescription>{t("inflationStepper.error.changeFailedDescription")}</Styled.BodyDescription>

            <Styled.Spacer />

            <Styled.ContinueButtonWrapper>
                <Styled.ContinueButton
                    onClick={() => {
                        modal?.remove();
                    }}
                >
                    {t("global.iUnderstand")}
                </Styled.ContinueButton>
            </Styled.ContinueButtonWrapper>
        </>
    );
};
